import {
    createContext,
    useContext
} from "react";
import type {
    AttachedGroupItemContextType
} from "./type";

export const AttachedGroupItemContext = createContext<AttachedGroupItemContextType | undefined>(undefined);

export const useAttachedGroupItem = (): AttachedGroupItemContextType | undefined => {
    return useContext(AttachedGroupItemContext);
};
